import React from "react";
import { useForm, Controller } from "react-hook-form";
import { TutorialContainer } from "../../../_components";

export function TimelineSetupPage({ onSubmit, store, formRef }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      timelineName: store.timelineName || "",
      timelinePrivate: store.timelinePrivate,
      timelineSubgroups: store.timelineSubgroups || [],
    },
  });
  return (
    <div className="chronos-timeline-setup-page">
      {/* GIF */}
      <TutorialContainer
        type="video"
        url="https://wa-cdn.nyc3.cdn.digitaloceanspaces.com/chronos/5e7d1b8b-b1c3-4406-a537-47c3d636426f.webm"
      />
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <div className="content-page-wrapper">
          <h2 className="chronos-wizard-page-title">
            Name your first Timeline
          </h2>
          <p className="chronos-wizard-text">
            Almost there! Just name your first timeline.
          </p>

          <div className="form-group">
            <Controller
              control={control}
              name="timelineName"
              id="timelineName"
              as="input"
              placeholder="Default Timeline"
              className="form-control"
            />
            <p className="chronos-wizard-hint">
              You can right click on your timeline (after this set-up) to add
              events!
            </p>
          </div>
        </div>
      </form>
    </div>
  );
}
